import axios from "axios";
import API_BASE_URL from '../../config';

export const GetCoursesServices = async (token) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const responseCourses = await axios.get(`${ API_BASE_URL }api/get-courses/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
  
    // console.log(responseCourses.data)
    return responseCourses.data;


    } catch (error) {
      console.error('Error en la solicitud:', error.response ? error.response.data : error.message);
      throw error;
    }
};